export const TYPE_DESKTOP = 0;
export const TYPE_MOBILE = 1;
export const TYPE_DEFAULT = Infinity;